export default {
  headerContent: {
    title: 'Özel Sağlık Sigortası',
    slogan: "Özel Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'ÖZEL SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Groupama Sigorta Özel Sağlık Trafik Sigortası',
    description: {
      title: 'Groupama Sigorta Özel Sağlık Sigortası Nedir? ',
      content: [
        'Günlük yaşantınızda beklemediğiniz ama karşılaşabileceğiniz sağlık riskleri bulunmaktadır. Bir sağlık sigortası poliçesi, kazalar, hastalıklar veya yaralanmalar nedeniyle ortaya çıkan tıbbi harcamalara karşı kapsamı genişletir. Birey, belirli bir görev süresi için aylık veya yıllık prim ödemelerine karşı böyle bir politikadan yararlanabilir. Bu süre içerisinde sigortalı bir kaza ile karşılaşırsa veya ağır bir rahatsızlık teşhisi konulursa tedavi amaçlı yapılan masraflar sigorta şirketi tarafından karşılanır.',
        'Groupama Sigorta bu riskleri özel sağlık sigortası ile güvence altına alarak hem size hem de ailenize geniş kapsamlı güvence sağlar.',
        'Sağlık sigortası, rutin hayatımızı idame ettirirken kaza veya hastalık sonucu almamız gereken tedavi masraflarını poliçede belirlenmiş teminat limitleri dâhilinde karşılar.'
      ]
    },
    subContent: {
      title: 'Groupama Sigorta Özel Sağlık Sigortası Planları Nelerdir?',
      content: [
        {
          paragraph:
            'Groupama Sigorta müşterilerine özel olarak 4 farklı plan sunmaktadır.',
          subList: null
        },
        {
          paragraph: 'Bu planlar;',
          subList: [
            'Ailem ',
            'Çocuğum',
            'Yeni hayat',
            'Vip olarak isimlendirilmiştir.'
          ]
        },
        {
          paragraph:
            '**Kendinize en uygun planı seçmek için sağlık sigortası uzmanlarımızdan destek alabilirsiniz.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Özel Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Özel Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Özel Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Özel Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Özel Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Groupama Sigorta Özel Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Groupama Sigorta Ailem Planı Nedir?',
      content: [
        {
          paragraph:
            'Ailem planı ile sadece kendinizin sağlığını değil aile bireylerinizin de sağlığını güvence altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Yatarak Tedavi Planı:</u></em></strong> Türkiye sınırları içinde Groupama Sigorta ile anlaşmalı hastanelerde yatarak tedavi hizmeti karşılamaktadır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Standart Plan:</u></em></strong> Yatarak tedavileri %20 katılım payı ile ödemek koşuluyla ve ek olarak ayakta tedavi hizmetlerini 3000’TL ye kadar karşılamaktadır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Ailem Plus:</u></em></strong> Standart plandan farklı olarak yatarak tedavilerde katılım payı yoktur. Ayakta tedavilerinizin limiti 4000’TL’dir.',
          subList: null
        }
      ]
    },
    {
      title: 'Groupama Sigorta Çocuğum Planı Nedir?',
      content: [
        {
          paragraph:
            'Groupama Sigorta sağlık sigortası kapsamında yer alan çocuğum planı ile 0-18 yaş arası ailenizin gözde bireyleri çocuklarınızın sağlığınızı güvence altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Çocuğum Planı Teminatları Nedir?',
      content: [
        {
          paragraph:
            '0 – 18 yaş arası çocuklarınıza yaptırabileceğiniz bu plan ile çocuklarınızın yatarak tedavilerini % 20 katılım payı ödeyerek ve ayakta tedavilerini 4000 TL’ye kadar güvence altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Groupama Sigorta Yeni Hayat Planı Nedir?',
      content: [
        {
          paragraph:
            'Yeni hayat poliçesi ile günlük yaşamınızda karşılaşabileceğiniz sağlık risklerini güven altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Yatarak Tedavili Plan:</u></em></strong> Bu teminat ile yatarak tedavilerinizi anlaşmalı hastanelerde limitsiz olarak ve 5000 TL limitli doğum teminatı ile %20 ödemek koşuluyla rutin kontroller güvence altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Yatarak Tedavili Plus Planı</u></em></strong>: Yatarak tedavi paketinden farklı olarak doğum teminatınızda limit bulunmamaktadır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Standart Plan:</u></em></strong> Standart planı %20 katılım payı ile limitsiz yatarak tedavi hizmeti ile birlikte 4000 TL limitli ayakta tedavi ve 7000 TL limitli doğum teminatı ile birlikte % 20 katılım payıyla rutin kontroller güvence altına alınmaktadır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Yeni Hayat Plus:</u></em></strong> Yeni hayat plus teminatı anlaşmalı hastanelerde limitsiz ayakta ve yatarak tedavi teminatına ek olarak Limitsiz Doğum Teminatı ve %20 Katılım Paylı Rutin Kontroller Teminatı sunulmaktadır.',
          subList: null
        },
        {
          paragraph:
            'Bu pakette ek olarak 50.000 EUR Yurtdışı Tedavi Teminatından da yararlanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Groupama Sigorta Vip Planı Nedir?',
      content: [
        {
          paragraph:
            'Vip plan ile normal poliçeden farklı olarak sağlığınız yurt dışında da Groupama Sigorta güvencesi altında olur.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Aksağlık VIP:</u></em></strong> Bu paketle yurt dışında ihtiyacınız olan sağlık harcamalarınız güvence altındadır. Özellikle yurt dışına çok sık seyahat ediyorsanız bu plan sizin için ideal olacaktır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Standart Plan:</u></em></strong> Bu paket ile %20 katılım payıyla limitsiz yatarak tedavi ve 3000 TL ayakta tedavi hizmetlerine ek olarak 50.000 EUR Yurt Dışı Tedavi Teminatı da bulunur.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>VIP Plus:</u></em></strong> Bu paket ile ayakta ve yatarak tedavileriniz limitsiz olarak karşılanmaktadır. Ek olarak 50.000 EUR Yurt Dışı Tedavi Teminatı da bulunur.',
          subList: null
        }
      ]
    },
    {
      title: 'Groupama Sigorta Özel Sağlık Sigortası Doğumu Karşılıyor Mu?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası poliçenize doğum teminatını ekletmeniz koşuluyla doğumunuzu güvence altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Groupama Sigorta Özel Sağlık Sigortası Doğumu Bekleme Süresi Ne Kadar?',
      content: [
        {
          paragraph:
            'Doğum teminatında bulunan bekleme süresi 5 aydır. Poliçe başlangıcından 5 ay sonra hamile kalınması koşulu bulunmaktadır. Bekleme süresinin tamamlanması sonucunda doğum masraflarınız güvence altında olur.',
          subList: null
        }
      ]
    },
    {
      title:
        'Groupama Sigorta Özel Sağlık Sigortası Kaç Yaşına Kadar Yapılıyor?',
      content: [
        {
          paragraph:
            'Groupama Sigorta 0-60 yaş arası olan kişilere sağlık sigortası hizmeti sunmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Groupama Sigorta Özel Sağlık Sigortası Ömür Boyu Yenileme Garantisi Nedir?',
      content: [
        {
          paragraph:
            'Ömür boyu yenileme garantisi mevcuttaki kapsamı ile ömür boyu yenileme garantisini taahhüt eder.',
          subList: null
        }
      ]
    },
    {
      title: 'Groupama Sigorta Özel Sağlık Sigortası Ne Zaman Başlar?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası düzenledikten sonra prim ödemesi gerçekleşmesi gerekmektedir. Poliçe primi ödendikten sonra yürürlüğe girmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Groupama Sigorta Özel Sağlık Sigortası Nerelerde Geçerli?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası kapsamında Groupama Sigorta ile anlaşmalı tüm hastanelerden hizmet alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Kimler Özel Sağlık Sigortası Yaptırabilir?',
      content: [
        {
          paragraph:
            'Groupama Sigorta’dan sağlık poliçesi alabilmek için tek şart kişinin 19 – 60 yaş olmasıdır. Bu şartı sağlayan her birey sigorta yaptırabilir. 0-18 yaş bireylerin sigorta ettireni 18 yaş üstü olması gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Groupama Sigorta Sağlık Sigortama Eşimi ve Çocuklarımı Dâhil Ettirebilir Miyim?',
      content: [
        {
          paragraph:
            'Groupama Sigorta’dan alacağınız ailem paketi ile kendinizin, eşinizin ve çocuklarınızın sağlığını güvence altına alabilirsiniz. Aile sağlık sigortası ile hem primlerinizden avantaj sağlarsınız hem de ailenizin sağlığını koruma altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Groupama Sigorta Sağlık Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Hem kendi sağlığınızı hem de ailenizin sağlığını hayattaki risklere karşı güvence altına almak istiyorsanız doğru yerdesiniz.',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan sağlık uzmanı danışmanımızla iletişime geçerek özel sağlık sigortası hakkında detaylı bilgi talep edebilirsiniz. ',
          subList: null
        }
      ]
    },
    {
      title: 'Groupama Sigorta Özel Sağlık Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'Özel (Bireysel) sağlık sigortası primleri yaş, boy, kilo geçmiş dönem kullanımları ve istenen plana göre değişmektedir.',
          subList: null
        },
        {
          paragraph:
            'Size özel hazırlanmış teklifi değerlendirmek ve poliçe tanzimi gerçekleştirmek için Alokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan sağlık uzmanı danışmanımızla iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
